import type { User } from '../types/auth';
import { isSnapfyInternal } from './snapfyInternal';

/**
 * Segmentos da Snapfy. "fashion" é a plataforma de sempre; "marketing" é a
 * plataforma de anúncios (Marketing Studio), com menu e fluxo próprios.
 * O segmento é derivado da URL — tudo sob /marketing é Marketing — então link
 * direto, reload e voltar do navegador sempre mostram o menu certo. O
 * /marketing-studio antigo continua no Fashion até ser migrado para dentro do
 * segmento (hoje ele não tem item no menu Marketing).
 */
export type AppSegment = 'fashion' | 'marketing';

export const SEGMENT_HOME: Record<AppSegment, string> = {
  fashion: '/',
  marketing: '/marketing',
};

export const getSegment = (pathname: string): AppSegment =>
  /^\/marketing(?:\/|$)/.test(pathname) ? 'marketing' : 'fashion';

/**
 * Quem vê o seletor de segmentos. Enquanto a plataforma Marketing está em
 * construção, só a equipe Snapfy (@snapfy.ai verificada) — trocar aqui por um
 * módulo quando abrir para clientes.
 */
export const canUseMarketingSegment = (user: User | null | undefined): boolean => isSnapfyInternal(user);

const storageKey = (segment: AppSegment) => `snapfy_segment_last_${segment}`;

/** Última rota visitada em cada segmento, para o seletor voltar de onde parou. */
export const rememberSegmentPath = (segment: AppSegment, path: string): void => {
  try {
    localStorage.setItem(storageKey(segment), path);
  } catch {
    /* storage indisponível: o seletor cai na home do segmento */
  }
};

export const lastSegmentPath = (segment: AppSegment): string => {
  try {
    const saved = localStorage.getItem(storageKey(segment));
    if (saved && getSegment(saved.split('?')[0]) === segment) return saved;
  } catch {
    /* storage indisponível */
  }
  return SEGMENT_HOME[segment];
};
